import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants } from 'src/app/shared/index';
export interface Widget {
  refNo: string;
  widgetId: string;
  widgetname: string;
  description: string;
  enabled: boolean;
}

@Component({
  selector: 'app-widget-configuration',
  templateUrl: './widget-configuration.component.html',
  styleUrls: ['./widget-configuration.component.scss']
})
export class WidgetConfigurationComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  widgets: MatTableDataSource<any>;
  displayedColumns = ['widgetname', 'description', 'enabled'];
  siteId: string;
  siteModel: SiteModel;

  constructor(
    private alertService: AlertService,
    private siteStepperService: SiteStepperService,
    private siteService: SiteService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.WidgetConfiguration &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        this.loadWidgets();
      }
    });
    // const widgets = [{ "refNo": null, "widgetname": "Loading Analysis", "description": "Analysing the loads i.e which load is getting over loaded or under loaded", "configprop": "Base", "enabled": true, "rId": "#350:1" }, { "refNo": null, "widgetname": "Energy Consumption Analysis", "description": "Analysing the total energy consumed by the loads for a period of time", "configprop": "Base", "enabled": true, "rId": "#350:2" }, { "refNo": null, "widgetname": "Comparision Analysis", "description": "Analysing the behaviour of peers of load and also self comparison of the load", "configprop": "Base", "enabled": true, "rId": "#350:3" }, { "refNo": null, "widgetname": "Stratification Tank View", "description": "Tab in Top Widget to view Stratification Tank Information", "configprop": "Customer Specific", "enabled": true, "rId": "#351:1" }, { "refNo": null, "widgetname": "Left Panel", "description": "It contains the site info and IEP project info", "configprop": "Base", "enabled": true, "rId": "#351:2" }, { "refNo": null, "widgetname": "On Time Analysis", "description": "Analysing the time for which the loads were ON", "configprop": "Base", "enabled": true, "rId": "#352:0" }, { "refNo": null, "widgetname": "Top Widget", "description": "Have Four tabs i.e Layout View, Energy Dashboard, Real Time Information and Deep Dive Information", "configprop": "Base", "enabled": true, "rId": "#352:1" }, { "refNo": null, "widgetname": "Load Tree", "description": "Information of loads present in the industry connected to meters", "configprop": "Base", "enabled": true, "rId": "#352:2" }, { "refNo": null, "widgetname": "Solar Dashboard", "description": "Tab in Top Widget to view Solar Dashboard", "configprop": "Customer Specific", "enabled": true, "rId": "#740:0" }, { "refNo": null, "widgetname": "Transformer Monitoring", "description": "Tab in Top Widget to view Transformer Monitoring  Information", "configprop": "Customer Specific", "enabled": true, "rId": "#740:1" }, { "refNo": null, "widgetname": "Peak Power Analysis", "description": "Analysing the maximum power supplied continuously", "configprop": "Customer Specific", "enabled": false, "rId": "#350:0" }, { "refNo": null, "widgetname": "Mains Power Factor", "description": "Analysing the compatibility between what comes out of an electric outlet and the load that is plugged into it", "configprop": "Customer Specific", "enabled": false, "rId": "#351:0" }, { "refNo": null, "widgetname": "Generic Dashboard", "description": "Tab in Top Widget to view Flow Management Dashboard", "configprop": "Customer Specific", "enabled": false, "rId": "#353:0" }, { "refNo": null, "widgetname": "TestBench Overview ", "description": "Tab in Top Widget to view TestBench Overview", "configprop": "Customer Specific", "enabled": false, "rId": "#353:1" }, { "refNo": null, "widgetname": "TestBench Overview", "description": "Tab in Top Widget to view TestBench Overview", "configprop": "Customer Specific", "enabled": false, "rId": "#353:2" }, { "refNo": null, "widgetname": "Hydraulic Unit View", "description": "Tab in Top Widget to view Hydraulic Unit Information", "configprop": "Customer Specific", "enabled": false, "rId": "#740:2" }];
    // this.widgets = new MatTableDataSource<Widget>(widgets);
    // this.widgets.paginator = this.paginator;
    // this.sort.sort(({ id: 'widgetname', start: 'asc' }) as MatSortable);
    // this.widgets.sort = this.sort;
  }

  loadWidgets() {
    this.siteService.getAllWidgetsBySiteId(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        this.widgets = new MatTableDataSource<Widget>(data);
        this.sort.sort({ id: 'widgetname', start: 'asc' } as MatSortable);
        this.widgets.sort = this.sort;
        this.widgets.paginator = this.paginator;
      }
    });
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.AlertsConfiguration, this.siteModel)
    );
  };
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ReportConfiguration, this.siteModel)
    );
  };
  saveWidgetConfig() {
    const dataWidgets = this.widgets.data;
    this.siteService
      .saveWidgetsConfig(dataWidgets, this.siteId)
      .subscribe((data) => {
        if (data === true) {
          this.alertService.showSuccess(Constants.MESSAGE.Save_success);
        } else {
          this.alertService.showError(Constants.MESSAGE.Save_failure);
        }
      });
  }
}
